import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "card-title fw-bolder text-dark" }
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = ["id"]
const _hoisted_5 = { class: "flex-grow-1" }
const _hoisted_6 = ["href", "target", "alt"]
const _hoisted_7 = {
  key: 0,
  class: "text-muted d-block fw-bold"
}
const _hoisted_8 = {
  key: 1,
  class: "flex-grow-1"
}
const _hoisted_9 = {
  class: "badge badge-success fw-bold",
  style: {"float":"right"}
}
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Symbol = _resolveComponent("Symbol")!
  const _component_ScrollableContent = _resolveComponent("ScrollableContent")!
  const _component_AsDataTable = _resolveComponent("AsDataTable")!
  const _component_ModalView = _resolveComponent("ModalView")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["card", _ctx.customClasses])
    }, [
      (_ctx.title)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "card-header border-0",
            id: `list_card_header_${_ctx.random}`
          }, [
            _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.title), 1),
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.subtitle), 1)
          ], 8, _hoisted_1))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "card-body pt-2",
        id: `list_card_body_${_ctx.random}`
      }, [
        _createVNode(_component_ScrollableContent, {
          scroll: _ctx.scrollStatus,
          header: `#list_card_header_${_ctx.random}`,
          body: `#list_card_body_${_ctx.random}`,
          height: _ctx.scrollH
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: _normalizeClass([{ 'mb-7': _ctx.items.length - 1 !== index }, "d-flex align-items-center"])
              }, [
                (item.avatar)
                  ? (_openBlock(), _createBlock(_component_Symbol, {
                      key: 0,
                      text: item.avatar,
                      size: "small",
                      customClass: "me-5"
                    }, null, 8, ["text"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("a", {
                    href: item.textLink ?? '#',
                    target: item.textLink ? '_blank' : '_self',
                    alt: item.text,
                    class: "text-dark fw-bolder text-hover-primary fs-6"
                  }, _toDisplayString(item.text), 9, _hoisted_6),
                  (item.description)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(item.description), 1))
                    : _createCommentVNode("", true)
                ]),
                (item.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(item.value), 1)
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128))
          ]),
          _: 1
        }, 8, ["scroll", "header", "body", "height"])
      ], 8, _hoisted_4),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("button", {
          class: "btn btn-sm",
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showAll()))
        }, _toDisplayString(_ctx.showAllText), 1)
      ])
    ], 2),
    _createVNode(_component_ModalView, {
      ref: "showAllmodal",
      "header-text": _ctx.title,
      id: 'showAllId_' + _ctx.random
    }, {
      body: _withCtx(() => [
        _createVNode(_component_AsDataTable, {
          items: _ctx.modalItems,
          header: _ctx.modalHeader,
          ref: "showAllDatatableRef",
          id: `showAllDatatable`,
          exportable: false,
          searchable: false,
          "no-pagination": true
        }, null, 8, ["items", "header"]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("b", null, _toDisplayString(_ctx.modalSubTitleText), 1)
        ])
      ]),
      _: 1
    }, 8, ["header-text", "id"])
  ], 64))
}